import { useLiveData } from './useLiveData';
import { ipApi } from '../services/api';

/** Hospital doctors, staff list, default pricing — all roles. */
export function useHospitalDirectory() {
  return useLiveData(() => ipApi.getStaffDirectory(), []);
}

export function formatDoctorOption(doc) {
  const sp = doc.specialty ? ` (${doc.specialty})` : '';
  return `${doc.name}${sp}`;
}
